import { httpApi } from '@api/http.api.ts';
import type { TASK_STATUS } from '@routes/sidebar/___shared___/components/pathway-menu/constants.ts';
import type { AssessorOption, AssessorTaskDecision } from '@routes/sidebar/admin-center/assessor/___shared___/types.ts';
import type { CommonSearchRequest, EmptyResultsDescription, PaginatedResponse } from '@types';

export type AssessorTaskStatus = (typeof TASK_STATUS)[keyof typeof TASK_STATUS];

export interface AssessorTaskItem {
    userPathwayId: number;
    pathwayId: number;
    userId: number;
    pathwayItemId: number;
    status: AssessorTaskStatus;
    isExemption: boolean;
    dateUTC: string | null;
    assesseeName: string;
    assesseeRank: string;
    attempts: number;
    taskElementTitle: string;
    assessorId: number | null;
    assessorName: string;
    assessorRank: string;
    location: string;
    availableAssessors: AssessorOption[];
    decision: AssessorTaskDecision | null;
}

export type AssessorTaskRequest = CommonSearchRequest;
export type AssessorTaskResponse = PaginatedResponse<AssessorTaskItem, EmptyResultsDescription>;

const ASSESSOR_TASKS_BASE_URL = 'admin-center/assessors/user-pathways';

export const searchAssessorQueue = (payload: AssessorTaskRequest): Promise<AssessorTaskResponse> =>
    httpApi.post<AssessorTaskResponse>(`${ASSESSOR_TASKS_BASE_URL}/tasks/search`, payload).then(({ data }) => data);

export const searchAssessorHistory = (payload: AssessorTaskRequest): Promise<AssessorTaskResponse> =>
    httpApi
        .post<AssessorTaskResponse>(`${ASSESSOR_TASKS_BASE_URL}/tasks/history/search`, payload)
        .then(({ data }) => data);
